import { useEffect } from 'react';
import { MetaPixelService } from '../services/metaPixel';

const MetaPixel: React.FC = () => {
  useEffect(() => {
    // Initialize Meta Pixel when component mounts
    MetaPixelService.initialize();
  }, []);

  return null; // This component doesn't render anything
};

export default MetaPixel;